import gql from "graphql-tag";

const queryGetAllUser = gql`
  query($limit: Int, $page: Int, $query: String, $status: String) {
    users(
      paging: { limit: $limit, page: $page }
      query: $query
      filter: { status: $status }
    ) {
      id
      email
      username
      fullname
      status
      adminOfLocationId
      adminOfLocation {
        id
        name
      }
      position {
        id
        name
      }
      department {
        id
        name
      }
      employee {
        id
        fullname
      }
    }
  }
`;

const queryGetUpdateEmployee = gql`
  query($id: ID!) {
    getEmployee(id: $id) {
      id
      code
      email
      fullname
      birthday
      positionId
      departmentId
      userId
      gender
      concurrentPositions {
        id
      }
      position {
        id
        name
        status
      }
      department {
        id
        name
        status
      }
      branchLocation {
        id
        name
      }
      branchLocationId
      user {
        id
        fullname
        username
        email
      }
      annualLeaveDay {
        id
        remain
        default
      }
      sickLeaveDay {
        id
        remain
        default
      }
      createdAt
      updatedAt
      author {
        id
        fullname
      }
    }
  }
`;

const queryGetAllDepartment = gql`
  query($status: String) {
    getAllDepartment(status: $status) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

const queryGetAllPosition = gql`
  query($status: String) {
    getAllPosition(status: $status) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

// Start USER query

export const queryGetDetailUser = gql`
  query getUser($id: ID!) {
    getUser(id: $id) {
      id
      fullname
      username
      email
      status
      directManagerId
      adminOfLocationId
      adminOfLocation {
        id
        name
      }
      directManager {
        id
        username
        fullname
        employeeId
        email
      }

      position {
        id
        name
        status
      }
      department {
        id
        name
        status
      }
      employee {
        id
        code
        email
        fullname
        birthday
        gender
        concurrentPositions {
          id
        }
        position {
          id
          name
          status
        }
        department {
          id
          name
          status
        }
        user {
          id
          fullname
        }
      }
    }
  }
`;

export default {
  queryGetUpdateEmployee,
  queryGetAllUser,
  queryGetAllDepartment,
  queryGetAllPosition,
};
